import { OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormsService } from '../../../_services/forms.service';
import { ClientsService } from '../../../_services/clients.service';
import { ActivatedRoute } from '@angular/router';
import { APP_DATE_FORMATS } from '../../../_pipes/angular2-material-datepicker-custom-date';
import * as moment from 'moment';
import { PreviousUrlService } from '../../../_services/previous-url.service';
import { PageTitleService } from '../../../_services/page-title.service';
import { environment } from '../../../../environments/environment';
const ɵ0 = APP_DATE_FORMATS;
export class ClientChangeNextInspectionDateComponent {
    constructor(clientsService, formsService, activatedRoute, previousUrlService, formBuilder, pageTitleService) {
        this.clientsService = clientsService;
        this.formsService = formsService;
        this.activatedRoute = activatedRoute;
        this.previousUrlService = previousUrlService;
        this.formBuilder = formBuilder;
        this.pageTitleService = pageTitleService;
        this.routerTransition = true;
        this.client_id = null;
        this.dataLoaded = false;
        this.isOffline = false;
        this.nextInspectionDetails = null;
        this.changeNextInspectionDateForm = this.formBuilder.group({
            next_inspection_date: ['', Validators.required],
            next_inspection_date_input: ['', Validators.required]
        });
        this._errorsSubscription = null;
        this._activatedRouteSubscription = null;
    }
    ngOnInit() {
        this.formsService.form = this.changeNextInspectionDateForm;
        this._errorsSubscription = this.clientsService.errors.subscribe(errors => {
            this.formsService.processErrors(errors);
        });
        this._activatedRouteSubscription = this.activatedRoute.params.subscribe((params) => {
            this.client_id = parseInt(params['client_id'], 10);
            this.clientsService.getClient(this.client_id).then((client) => {
                if (typeof client !== 'undefined') {
                    this.pageTitleService.setTitle(client.company_name + ' | Aanpassen aankomende inspectie datum | ' + environment.webappName);
                    this.pageTitleService.setPageTitle(client.company_name);
                }
            });
            this.previousUrlService.setPreviousUrlIfNull('/clients/' + this.client_id + '/view');
            this.clientsService.getChangeNextInspectionDate(this.client_id).then((nextInspectionDetails) => {
                if (typeof nextInspectionDetails !== 'undefined') {
                    this.changeNextInspectionDateForm.get('next_inspection_date').setValue(new Date(nextInspectionDetails.next_inspection_date));
                    this.nextInspectionDetails = nextInspectionDetails;
                    this.dataLoaded = true;
                }
                else {
                    this.isOffline = true;
                }
            });
        });
    }
    ngOnDestroy() {
        if (this._activatedRouteSubscription !== null) {
            this._activatedRouteSubscription.unsubscribe();
        }
        if (this._errorsSubscription !== null) {
            this._errorsSubscription.unsubscribe();
        }
    }
    updateNextInspectionDate($event) {
        this.changeNextInspectionDateForm.get('next_inspection_date').setValue(moment($event.value).format('DD-MM-YYYY'));
    }
}
export { ɵ0 };
